<div class="modal-header">
    <h6 class="modal-title medium">{{'employeeTransfer'| translate}}</h6>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.close('Cross click')">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="w-100 float-left modal-body">
    <div class="col-lg-12 col-md-12 float-left mb-1">
        <p>{{'currently' | translate}}
            <span class="text-primary medium"> {{employeeData.displayName}} </span> {{'partOfProgram' | translate}}</p>
    </div>
    <div class="col-lg-12 col-md-12 float-left mb-4 b-b pb-4" *ngFor="let scorecardList of allScoreCardData;index as i">
        <div class="w-100 float-left align-v-center">
            <div *ngIf="scorecardList.state != 'UPDATEDUE' && scorecardList.state != 'SUBMIT_REVIEW' && 
            scorecardList.state != 'PENDING_REVIEW_VERIFICATION' && scorecardList.state != 'NEED_INFO_SUPERVISOR' 
            && scorecardList.createNextScorecard == null" class="checkbox checkbox-primary">
                <input id="id_{{i}}" type="checkbox" (change)="checkSelected(i,$event)">
                <label for="id_{{i}}" class="mb-0"></label>
            </div>
            <p class="m-t-nsm mb-0 ml-2 medium"> {{scorecardList.scorecardName}} </p>
        </div>
        <p class="text-12x mb-1 pl-4 w-100 float-left"> {{scorecardList.startDate}} {{'to' | translate}}
            {{scorecardList.endDate}} </p>
        <p class="text-13x pl-4 mb-1 w-100 float-left text-primary font-italic">
            <i class="fa fa-check-square mr-1 text-primary"></i> {{scorecardList.state}} </p>
        <div class="col-lg-6 col-md-6 float-left mb-4 left-clear"
             *ngIf="scorecardList.state != 'UPDATEDUE' && scorecardList.state != 'SUBMIT_REVIEW' && scorecardList.state != 'PENDING_REVIEW_VERIFICATION' && scorecardList.state != 'NEED_INFO_SUPERVISOR' && scorecardList.createNextScorecard == null">
            <input class="form-control" placeholder="YYYY-MM-DD" name="endDate" ngbDatepicker #endDate="ngbDatepicker"
                   [(ngModel)]="modelArray[i]"
                   [minDate]="getFormatedDate(scorecardList.startDate)"
                   [maxDate]="getFormatedDate(scorecardList.endDate)" (ngModelChange)="programEndDateChanged($event,i)"
                   required readonly>
            <button class="iga-right" (click)="endDate.toggle()" type="button">
                <i class="fa fa-calendar"></i>
            </button>
        </div>
        <div class="w-100 float-left">
            <ul class="text-10x m-0">
                <ng-container *ngIf="scorecardList.createNextScorecard != null;else second">
                    <li>{{'transferInitiated'| translate}}</li>
                </ng-container>
                <ng-template #second>
                    <ng-container
                            *ngIf="scorecardList.state == 'UPDATEDUE' || scorecardList.state == 'SUBMIT_REVIEW' || scorecardList.state == 'PENDING_REVIEW_VERIFICATION' || scorecardList.state == 'NEED_INFO_SUPERVISOR';else third">
                        <li>{{'reviewCloseAndTry'| translate}}</li>
                    </ng-container>
                </ng-template>
                <ng-template #third>
                    <li>{{'reviewWillBeTriggered' | translate}}</li>
                    <li>{{'consecutiveScoreCardCreated' | translate}}</li>
                    <li>{{'targetCalculated' | translate}}</li>
                    <li>{{'convertedSupportingKpi' | translate}}</li>
                    <li>{{'onceKpi'| translate}}</li>
                    <li *ngIf="scorecardList.state == 'PENDING_VERIFICATION' || scorecardList.state == 'SUBMITTED' || scorecardList.state == 'PUBLISHED' || scorecardList.state == 'PUBLISH_REVIEW'">
                        {{'resetBackToCreateState' | translate}}
                    </li>
                </ng-template>
            </ul>
        </div>
    </div>


</div>
<div class="modal-footer">

    <button class="btn btn-secondary float-right" (click)="confirm('Skip')"> {{'skip' | translate}}</button>
    <button class="btn btn-primary float-right" (click)="confirm('Transfer')"> {{'transfer' | translate}}</button>
</div>


// WEBPACK FOOTER //
// ./src/app/employee/employeeTransfer/employeeTransfer.html